import React, { useEffect } from 'react';
import './rc2024.css';
import { rc2024 } from '../../json/rc2024';

const Rc2024 = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className='container container-mh'>
      <div className='row'>
        <div className='col-12'>
          <h3 className='title'>Folios Seleccionados de los Programas Sociales 2024</h3>
          <hr className='hr-gob' />
        </div>
      </div>

      <div className='row'>
        <div className='col-12 container-armon'>
          <div className='armo-collapse'>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'left' }}>
             
              <div style={{ textAlign: 'left' }}>

              <h5 style={{ fontWeight: 'bold' }}><strong><a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/Rcs/2024/RC_BMS_2024.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Folios Seleccionados Programa Bienestar de Madres Solteras 2024</a></strong></h5>
                <p>
                </p>

                <h5 style={{ fontWeight: 'bold' }}><strong><a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/Rcs/2024/RC_BP_2024.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Folios Seleccionados Programa Bienestar y Producción 2024</a></strong></h5>
                <p>
                </p>

                <h5 style={{ fontWeight: 'bold' }}><strong><a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/Rcs/2024/RCV1_BD_2024.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Folios Seleccionados Programa Apoyo Para el Bienestar y Desarrollo 2024 Ventanilla 1</a></strong></h5>
                <p>
                </p>

                <h5 style={{ fontWeight: 'bold' }}><strong><a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/Rcs/2024/RCV2_BD_2024.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Folios Selecciondos Programa Apoyo Para el Bienestar y Desarrollo 2024 Ventanilla 2</a></strong></h5>
                <p>
                </p>

              </div>
            </div>
            
          </div>
        </div>
      </div>    
    </div>
  );
};

export default Rc2024;